import { Badge, Drawer, IconButton } from "@material-ui/core";
import CommentIcon from "@material-ui/icons/Comment";
import EditIcon from "@material-ui/icons/Edit";
import { HarvestUserLinkButton } from "harvest/HarvestUserLinkButton";
import { Engineer } from "resource-planner-model";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { CommentsPanelEditor } from "../../comments/CommentsPanelEditor";
import useComments from "../../comments/useComments";

export function EngineerLinkBar({
  year,
  month,
  engineer,
  comments: commentButton = true,
  notesKey = "",
}: {
  year: number;
  month: number;
  engineer: Engineer;
  comments?: boolean;
  notesKey?: string;
}) {
  const history = useHistory();
  const comments = useComments(year, month);
  const [commentId, setCommentId] = useState(undefined as string | undefined);

  function onComment(e: any) {
    const id = e?.currentTarget?.dataset?.id;
    setCommentId(`${notesKey}${id || ""}`);
  }

  function onEdit(e: any) {
    const path = e?.currentTarget?.dataset?.path;
    if (path) {
      history.push(path);
    }
  }

  function onOpen(e: any) {
    const url = e?.currentTarget?.dataset?.url;
    if (url) {
      window.open(url, "_blank");
    }
  }

  return (
    <span>
      <IconButton
        data-path={`/administration/engineers/${engineer?.id}`}
        onClick={onEdit}
      >
        <EditIcon />
      </IconButton>
      <HarvestUserLinkButton
        user={engineer?.harvestId}
        year={year}
        month={month}
      />
      {commentButton ? (
        <IconButton data-id={engineer?.id} onClick={onComment}>
          <Badge
            color="primary"
            badgeContent={comments[`${notesKey}${engineer?.id}`]?.length || 0}
          >
            <CommentIcon />
          </Badge>
        </IconButton>
      ) : null}
      <Drawer
        anchor="right"
        open={commentId !== notesKey && !!commentId}
        onClose={onComment}
        style={{ width: 400 }}
      >
        <CommentsPanelEditor
          year={year}
          month={month}
          id={commentId || ""}
        ></CommentsPanelEditor>
      </Drawer>
    </span>
  );
}
